module.exports = __webpack_public_path__ + "img/photo.954e9824.png";